import React, { useState, useEffect, forwardRef } from 'react';
import InputMask from 'react-input-mask';
import DatePicker from 'react-datepicker';
import { Form } from 'react-bootstrap';
import 'react-datepicker/dist/react-datepicker.css';
import { registerLocale } from 'react-datepicker';
import ptBR from 'date-fns/locale/pt-BR';

registerLocale('pt-BR', ptBR);

const DateInput = ({ label, value, onChange, error, placeholder, isEditing, userRoles}) => {
  const [date, setDate] = useState(value ? new Date(value + 'T00:00:00') : null);

  useEffect(() => {
    if (isEditing && value) {
      const parsedDate = parseDate(value);
      if (parsedDate) {
        setDate(parsedDate);
      }
    }
  }, [value, isEditing]);

  const parseDate = (dateString) => {
    const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (dateRegex.test(dateString)) {
      return new Date(dateString + 'T00:00:00');
    }

    const parts = dateString.split('/');
    if (parts.length === 3) {
      const day = parts[0];
      const month = parts[1];
      const year = parts[2];
      return new Date(`${year}-${month}-${day}T00:00:00`);
    }

    return null;
  };
  
  const handleDateChange = (data) => {
    setDate(data);
    if (data) {
      const formattedDate = data.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      });
      onChange(formattedDate);
    } else {
      onChange('');
    }
  };

  const handleInputBlur = (e) => {
    const inputValue = e.target.value;
    const dateRegex = /^\d{2}\/\d{2}\/\d{4}$/;

    if (dateRegex.test(inputValue)) {
      const [day, month, year] = inputValue.split('/').map(Number);
      const parsedDate = new Date(year, month - 1, day);
      if (parsedDate && parsedDate.getDate() === day && parsedDate.getMonth() === month - 1 && parsedDate.getFullYear() === year) {
        handleDateChange(parsedDate);
      } else {
        onChange('');
      }
    } else {
      onChange('');
    }
  };

  const CustomInput = forwardRef(({ value, onClick, onChange }, ref) => (
    <InputMask
      mask="99/99/9999"
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className={`form-control ${error ? 'is-invalid' : ''}`}
      onClick={onClick}
      onBlur={handleInputBlur}
      ref={ref}
      readOnly={userRoles}
    />
  ));

  return (
    <Form.Group className="mb-3 w-100">
      {label && <Form.Label className="mb-1 d-block">{label}</Form.Label>}
      <div className="position-relative">
        <DatePicker
          selected={date}
          onChange={handleDateChange}
          dateFormat="dd/MM/yyyy"
          locale="pt-BR"
          customInput={<CustomInput />}
          placeholderText={placeholder}
          readOnly={userRoles}
          autoComplete='off'
        />
        {error && <small className="text-danger mt-1 d-block">{error.message}</small>}
      </div>
    </Form.Group>
  );
};

export default DateInput;